import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "../../../components/settings/profile-page";

export const Route = createFileRoute("/_authenticated/_workspace/settings/profile")({
  component: ProfilePage,
});
